<template>
  <div>
    <KenticoResponsiveImage :src="image.url" :alt="image.description" :class="shape" :sizes="imageSizes" />
    <component :is="shape" :shape="shape" />
  </div>
</template>

<script>
import OurValuesShapeOne from '~/components/elements/OurValuesShapeOne.vue';
import OurValuesShapeTwo from '~/components/elements/OurValuesShapeTwo.vue';
import OurValuesShapeThree from '~/components/elements/OurValuesShapeThree.vue';
import { BREAKPOINTS, BREAKPOINT_MD } from '~/utils/constants';

export default {
  components: {
    OurValuesShapeOne,
    OurValuesShapeTwo,
    OurValuesShapeThree,
  },
  props: {
    shape: { type: String, required: true },
    image: {
      type: Object,
      required: true,
      default() {
        return {
          url: { type: String, required: true },
          description: { type: String, required: true },
        };
      },
    },
  },
  data() {
    return {
      imageSizes: {
        default: [600, 500],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 900, height: 750 },
        ],
      },
    };
  },
};
</script>
